/**
 * Archive Filters Functionality
 * Handles accordion-style filter toggles on the Events & Insights archive page
 */

(function($) {
	'use strict';

	$(document).ready(function() {
		
		// Toggle filter groups
		$('.filter-toggle').off('click').on('click', function() {
			var $button = $(this);
			var targetId = $button.data('target');
			var $content = $('#' + targetId);
			var $chevron = $button.find('.chevron');
			var isExpanded = $button.attr('aria-expanded') === 'true';
			
			// Toggle the content
			$content.slideToggle(300);
			
			// Toggle aria-expanded state for accessibility
			$button.attr('aria-expanded', !isExpanded);
			
			// Rotate the chevron
			$button.toggleClass('active');
		});

		// Keep filters open if they have checked items
		$('.filter-content').each(function() {
			var $content = $(this);
			var hasChecked = $content.find('input[type="checkbox"]:checked').length > 0;
			
			if (hasChecked) {
				$content.show();
				var $toggle = $content.prev('.filter-toggle');
				$toggle.addClass('active');
				$toggle.attr('aria-expanded', 'true');
			}
		});

	});

})(jQuery);

